import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";
import { GlobalDataService } from "../../services/faker/global-data.service";
import { AcademicClassActions } from "./academic.actions";

@Injectable()
export class AcademicClassEffects {
    constructor(
        private actions$: Actions,
        private globalDataService: GlobalDataService
    ) { }

    loadClasses$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AcademicClassActions.loadClasses),
            mergeMap(() => {
                const data = this.globalDataService.getAcademicClasses();
                if (data && data.length > 0) {
                    return of(data).pipe(
                        map(classes => AcademicClassActions.loadClassesSuccess({ classes })),
                        catchError(error => of(AcademicClassActions.loadClassesFailure({ error })))
                    );
                } else {
                    return of(AcademicClassActions.loadClassesFailure({ error: 'Academic class data not found' }));
                }
            })
        )
    );
}